import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Login from './pages/login';
import NutritionTracker from './pages/nutrition-tracker';
import ActiveWorkout from './pages/active-workout';
import MemberProfile from './pages/member-profile';
import WorkoutLibrary from './pages/workout-library';
import TrainerProfiles from './pages/trainer-profiles';
import ProgressAnalytics from './pages/progress-analytics';
import Register from './pages/register';
import MemberDashboard from './pages/member-dashboard';
import ClassSchedule from './pages/class-schedule';
import AdminDashboard from './pages/admin-dashboard';
import GymAnnouncements from './pages/gym-announcements';
import SocialLeaderboards from './pages/social-leaderboards';
import MemberChatSystem from './pages/member-chat-system';
import ChallengeSystem from './pages/challenge-system';
import EventsCalendar from './pages/events-calendar';
import AICoaching from './pages/ai-coaching';
import GymSettings from './pages/gym-settings';
import AIWorkoutRecommendations from './pages/ai-workout-recommendations';
import WorkoutCompletionLogger from './pages/workout-completion-logger';
import RecoveryInsights from './pages/recovery-insights';
import CommunityFeed from './pages/community-feed';
import RevenueDashboard from './pages/revenue-dashboard';
import MTTDemoGymLocation from './pages/mtt-demo-gym-location';
import MemberRetentionAnalytics from './pages/member-retention-analytics';
import WorkoutAnalyticsDashboard from './pages/workout-analytics-dashboard';
import AINutritionPlans from './pages/ai-nutrition-plans';
import MemberReferralSystem from './pages/member-referral-system';
import BarcodeAttendanceSystem from './pages/barcode-attendance-system';
import MemberBarcodeGenerator from './pages/member-barcode-generator';
import AttendanceReportDashboard from './pages/attendance-report-dashboard';
import MembershipManagementDashboard from './pages/membership-management-dashboard';
import MembershipPlanBuilder from './pages/membership-plan-builder';
import BillingSubscriptionCenter from './pages/billing-subscription-center';
import SuperAdminTenantManagement from './pages/super-admin-tenant-management';
import TenantBillingSuspensionDashboard from './pages/tenant-billing-suspension-dashboard';
import PaymentProcessorIntegration from './pages/payment-processor-integration';
import MemberPaymentMethods from './pages/member-payment-methods';
import MembershipAlertsManagement from './pages/membership-alerts-management';
import PaymentReconciliationDashboard from './pages/payment-reconciliation-dashboard';
import AIFitnessAssistantChatbot from './pages/ai-fitness-assistant-chatbot';
import AutomatedInvoiceManagementSystem from './pages/automated-invoice-management-system';
import AISupportTicketSystem from './pages/ai-support-ticket-system';
import NotificationsPage from './pages/notifications';
import LegalComplianceCenter from './pages/legal-compliance-center';
import PostWorkoutFeedbackSystem from './pages/post-workout-feedback-system';
import FeedbackAnalyticsDashboard from './pages/feedback-analytics-dashboard';
import PointOfSaleDashboard from './pages/point-of-sale-dashboard';
import ProductCatalogManagement from './pages/product-catalog-management';
import SalesAnalyticsReporting from './pages/sales-analytics-reporting';
import DailyCashReconciliationReports from './pages/daily-cash-reconciliation-reports/index';
import UserManagementDashboard from './pages/user-management-dashboard';
import RealTimeMemberAccessControl from './pages/real-time-member-access-control';
import ManualMemberRegistrationPortal from './pages/manual-member-registration-portal';
import QRCodeManagementCenter from './pages/qr-code-management-center';
import QRCodeScannerValidator from './pages/qr-code-scanner-validator';
import CashDrawerReconciliationCenter from './pages/cash-drawer-reconciliation-center';
import StaffAttendanceManagementSystem from './pages/staff-attendance-management-system';
import UniversalQRCodeGeneratorManagement from './pages/universal-qr-code-generator-management';
import PayrollManagementSystem from './pages/payroll-management-system';
import MemberBillingPortal from './pages/member-billing-portal';
import AdvancedReportBuilder from './pages/advanced-report-builder';
import InventoryManagementDashboard from './pages/inventory-management-dashboard';
import BulkProductImportSystem from './pages/bulk-product-import-system';
import RealTimeInventorySynchronizationCenter from './pages/real-time-inventory-synchronization-center';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/nutrition-tracker" element={<NutritionTracker />} />
        <Route path="/active-workout" element={<ActiveWorkout />} />
        <Route path="/member-profile" element={<MemberProfile />} />
        <Route path="/workout-library" element={<WorkoutLibrary />} />
        <Route path="/trainer-profiles" element={<TrainerProfiles />} />
        <Route path="/progress-analytics" element={<ProgressAnalytics />} />
        <Route path="/register" element={<Register />} />
        <Route path="/member-dashboard" element={<MemberDashboard />} />
        <Route path="/class-schedule" element={<ClassSchedule />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/gym-announcements" element={<GymAnnouncements />} />
        <Route path="/social-leaderboards" element={<SocialLeaderboards />} />
        <Route path="/member-chat-system" element={<MemberChatSystem />} />
        <Route path="/challenge-system" element={<ChallengeSystem />} />
        <Route path="/events-calendar" element={<EventsCalendar />} />
        <Route path="/ai-coaching" element={<AICoaching />} />
        <Route path="/gym-settings" element={<GymSettings />} />
        <Route path="/ai-workout-recommendations" element={<AIWorkoutRecommendations />} />
        <Route path="/workout-completion-logger" element={<WorkoutCompletionLogger />} />
        <Route path="/workout-analytics-dashboard" element={<WorkoutAnalyticsDashboard />} />
        <Route path="/recovery-insights" element={<RecoveryInsights />} />
        <Route path="/community-feed" element={<CommunityFeed />} />
        <Route path="/revenue-dashboard" element={<RevenueDashboard />} />
        <Route path="/mtt-demo-gym-location" element={<MTTDemoGymLocation />} />
        <Route path="/member-retention-analytics" element={<MemberRetentionAnalytics />} />
        <Route path="/ai-nutrition-plans" element={<AINutritionPlans />} />
        <Route path="/member-referral-system" element={<MemberReferralSystem />} />
        <Route path="/barcode-attendance-system" element={<BarcodeAttendanceSystem />} />
        <Route path="/member-barcode-generator" element={<MemberBarcodeGenerator />} />
        <Route path="/attendance-report-dashboard" element={<AttendanceReportDashboard />} />
        <Route path="/membership-management-dashboard" element={<MembershipManagementDashboard />} />
        <Route path="/membership-plan-builder" element={<MembershipPlanBuilder />} />
        <Route path="/billing-subscription-center" element={<BillingSubscriptionCenter />} />
        <Route path="/super-admin-tenant-management" element={<SuperAdminTenantManagement />} />
        <Route path="/tenant-billing-suspension-dashboard" element={<TenantBillingSuspensionDashboard />} />
        <Route path="/payment-processor-integration" element={<PaymentProcessorIntegration />} />
        <Route path="/member-payment-methods" element={<MemberPaymentMethods />} />
        <Route path="/membership-alerts-management" element={<MembershipAlertsManagement />} />
        <Route path="/payment-reconciliation-dashboard" element={<PaymentReconciliationDashboard />} />
        <Route path="/ai-fitness-assistant-chatbot" element={<AIFitnessAssistantChatbot />} />
        <Route path="/automated-invoice-management-system" element={<AutomatedInvoiceManagementSystem />} />
        <Route path="/payroll-management-system" element={<PayrollManagementSystem />} />
        <Route path="/ai-support-ticket-system" element={<AISupportTicketSystem />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/legal-compliance-center" element={<LegalComplianceCenter />} />
        <Route path="/post-workout-feedback-system" element={<PostWorkoutFeedbackSystem />} />
        <Route path="/feedback-analytics-dashboard" element={<FeedbackAnalyticsDashboard />} />
        <Route path="/point-of-sale-dashboard" element={<PointOfSaleDashboard />} />
        <Route path="/product-catalog-management" element={<ProductCatalogManagement />} />
        <Route path="/sales-analytics-reporting" element={<SalesAnalyticsReporting />} />
        <Route path="/daily-cash-reconciliation-reports" element={<DailyCashReconciliationReports />} />
        <Route path="/user-management-dashboard" element={<UserManagementDashboard />} />
        <Route path="/real-time-member-access-control" element={<RealTimeMemberAccessControl />} />
        <Route path="/manual-member-registration-portal" element={<ManualMemberRegistrationPortal />} />
        <Route path="/qr-code-management-center" element={<QRCodeManagementCenter />} />
        <Route path="/qr-code-scanner-validator" element={<QRCodeScannerValidator />} />
        <Route path="/cash-drawer-reconciliation-center" element={<CashDrawerReconciliationCenter />} />
        <Route path="/staff-attendance-management-system" element={<StaffAttendanceManagementSystem />} />
        <Route path="/universal-qr-code-generator-management" element={<UniversalQRCodeGeneratorManagement />} />
        <Route path="/member-billing-portal" element={<MemberBillingPortal />} />
        <Route path="/advanced-report-builder" element={<AdvancedReportBuilder />} />
        <Route path="/inventory-management-dashboard" element={<InventoryManagementDashboard />} />
        <Route path="/bulk-product-import-system" element={<BulkProductImportSystem />} />
        <Route path="/real-time-inventory-synchronization-center" element={<RealTimeInventorySynchronizationCenter />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
